module.exports = __webpack_public_path__ + "img/logo_velecta-paris_noir-1-2.960ddead.png";